// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","662":"29107295","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"a7b58084cf34a1fb1616","662":"54a6937b505bb43f2888","678":"5ff092e1561c46f206e6","883":"9f9cabc7e22196f8288c"}[chunkId] + ".js";
};